import { primaryColor } from 'views/services/color-scheme';

type DataToCreate = {
  div: HTMLDivElement;
}

class Map {

  private ready: boolean;

  readonly div: HTMLDivElement;
  readonly google: google.maps.Map;

  constructor(data: DataToCreate) {
    this.ready = false;
    this.div = data.div;
    this.google = this.getGoogleObject();
    this.init();
  }

  private getGoogleObject(): google.maps.Map {
    const options: google.maps.MapOptions = {
      center: { lat: 34.680931, lng: 135.582988 },
      zoom: 14,
      mapTypeControl: false,
      fullscreenControl: true,
      streetViewControl: false,
      zoomControl: true,
      styles: [
        {
          featureType: 'all',
          elementType: 'all',
          stylers: [
            { visibility: 'on' },
            { hue: primaryColor },
            { saturation: -33 },
            { lightness: 0 },
          ],
        },
      ],
    };
    return new google.maps.Map(this.div, options);
  }

  private init() {
    this.watch().then(() => {
      this.ready = true;
    });
  }

  async watch(): Promise<Map> {
    return new Promise(resolve => {
      if (this.ready) resolve(this);
      else google.maps.event.addListenerOnce(this.google, 'idle', () => resolve(this));
    });
  }

}

export default Map;